import { FileUploaderComponent } from './file-uploader.component';

export default angular
  .module('sfMobile.components.file-uploader', [
    'sfMobile.components.button-big',
    'sfMobile.components.input-file-upload',
  ])
  .component('sfFileUploader', FileUploaderComponent).name;
